<div class="page-layout">
  <mat-toolbar class="page-toolbar rounded">
    <span>Autonomy</span>
  </mat-toolbar>
  <mat-list class="horizontal-list">
    <mat-list-item
                   class="widget rounded"
                   *ngFor="let widget of widgets"
                   (click)="navigateToFleetDetails(widget.fleetId)">
      <div matListItemTitle class="bages">
        <div *ngFor="let bage of widget.bages" class="badge {{bage.color}}">{{bage.value}}</div>
      </div>
      <div matListItemLine class="fleet-image-container">
        <img class="fleet-image" alt="widget image"
          [src]="getImageUrl(widget.fileName)"
        />
      </div>
      <div matListItemLine class="fleet-info">
        {{widget.name}}
      </div>
    </mat-list-item>
  </mat-list>
</div>
